import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';

const BulkGenerationModal = ({ isOpen, onClose, onGenerate }) => {
  const [selectedTemplate, setSelectedTemplate] = useState('');
  const [selectedProperties, setSelectedProperties] = useState([]);

  const templateOptions = [
    { value: 'property-listing', label: 'نموذج قائمة العقار' },
    { value: 'client-intake', label: 'نموذج استقبال العميل' },
    { value: 'contract-template', label: 'قالب العقد' }
  ];

  const mockProperties = [
    { id: 1, name: 'فيلا فاخرة - دبي مارينا', type: 'فيلا', price: '٤٥٠٠٠٠٠' },
    { id: 2, name: 'شقة عصرية - وسط المدينة', type: 'شقة', price: '١٨٠٠٠٠٠' },
    { id: 3, name: 'مكتب تجاري - الخليج التجاري', type: 'مكتب', price: '٢٥٠٠٠٠٠' },
    { id: 4, name: 'محل تجاري - جميرا', type: 'محل', price: '٣٢٠٠٠٠٠' },
    { id: 5, name: 'أرض سكنية - البرشاء', type: 'أرض', price: '٥٥٠٠٠٠٠' }
  ];

  const handlePropertyToggle = (propertyId) => {
    setSelectedProperties(prev =>
      prev?.includes(propertyId)
        ? prev?.filter(id => id !== propertyId)
        : [...prev, propertyId]
    );
  };

  const handleSelectAll = () => {
    if (selectedProperties?.length === mockProperties?.length) {
      setSelectedProperties([]);
    } else {
      setSelectedProperties(mockProperties?.map(p => p?.id));
    }
  };

  const handleGenerate = () => {
    onGenerate({
      template: selectedTemplate,
      properties: selectedProperties
    });
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-background/80 backdrop-blur-sm">
      <div className="w-full max-w-3xl max-h-[90vh] bg-card rounded-lg shadow-warm-2xl overflow-hidden">
        <div className="flex items-center justify-between p-4 md:p-6 border-b border-border bg-muted/30">
          <Button
            variant="ghost"
            size="icon"
            onClick={onClose}
            iconName="X"
            iconSize={20}
          />
          <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground">
            إنشاء مستندات متعددة
          </h2>
        </div>

        <div className="p-4 md:p-6 space-y-6 overflow-auto max-h-[calc(90vh-180px)]">
          <div>
            <Select
              label="اختر القالب"
              options={templateOptions}
              value={selectedTemplate}
              onChange={setSelectedTemplate}
              placeholder="اختر قالب المستند"
              required
            />
          </div>

          <div>
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-base font-heading font-semibold text-foreground">
                اختر العقارات ({selectedProperties?.length} محدد)
              </h3>
              <Button
                variant="outline"
                size="sm"
                onClick={handleSelectAll}
              >
                {selectedProperties?.length === mockProperties?.length ? 'إلغاء الكل' : 'تحديد الكل'}
              </Button>
            </div>

            <div className="space-y-2 max-h-64 overflow-auto border border-border rounded-lg p-3">
              {mockProperties?.map((property) => (
                <div
                  key={property?.id}
                  className="flex items-center justify-between p-3 rounded-lg border border-border hover:bg-muted/50 transition-colors"
                >
                  <div className="flex items-center gap-3 flex-1">
                    <Checkbox
                      checked={selectedProperties?.includes(property?.id)}
                      onChange={() => handlePropertyToggle(property?.id)}
                    />
                    <div className="text-right">
                      <p className="text-sm font-medium text-foreground">{property?.name}</p>
                      <p className="text-xs text-muted-foreground">
                        {property?.type} • {property?.price} دينار أردني
                      </p>
                    </div>
                  </div>
                  <Icon name="Building2" size={20} color="var(--color-muted-foreground)" />
                </div>
              ))}
            </div>
          </div>

          <div className="p-4 rounded-lg bg-muted/30 border border-border">
            <div className="flex items-start gap-3">
              <Icon name="Info" size={20} color="var(--color-primary)" />
              <div className="text-right">
                <p className="text-sm font-medium text-foreground mb-1">
                  ملاحظة هامة
                </p>
                <p className="text-xs text-muted-foreground">
                  سيتم إنشاء {selectedProperties?.length} مستند بناءً على القالب المحدد. قد تستغرق العملية بضع دقائق حسب عدد المستندات.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-start gap-3 p-4 md:p-6 border-t border-border bg-muted/30">
          <Button
            variant="outline"
            onClick={onClose}
          >
            إلغاء
          </Button>
          <Button
            variant="default"
            iconName="FileText"
            iconPosition="right"
            onClick={handleGenerate}
            disabled={!selectedTemplate || selectedProperties?.length === 0}
          >
            إنشاء {selectedProperties?.length} مستند
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BulkGenerationModal;